import { render, staticRenderFns } from "./inspection-status.vue?vue&type=template&id=fc03afec&scoped=true"
import script from "./inspection-status.vue?vue&type=script&lang=js"
export * from "./inspection-status.vue?vue&type=script&lang=js"
import style0 from "./inspection-status.vue?vue&type=style&index=0&id=fc03afec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc03afec",
  null
  
)

export default component.exports